<template>
    <div :style="{ opacity: loaded ? 1 : 0 }" style="position: fixed;right:10px;bottom: 100px;" v-if="inviteShow">
        <div class="flex flex-h-end margin-b">
            <i @click="setInviteShow()" class="el-icon-circle-close" style="font-size: 20px;cursor: pointer;"></i>
        </div>
        <img @load="onLoad()" :src="$host + $store.state.setting.pte_qrcode" 
            style="width:140px;height: auto;border-radius: 10px;overflow: hidden;" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            loaded: false
        }
    },

    computed: {
        inviteShow: function () {
            return this.$store.state.inviteShow;
        }
    },
    methods: {
        setInviteShow() {
            this.$store.commit("set_invite_show", false)
        },

        onLoad() {
            this.loaded = true
        }
    }
}
</script>

<style></style>